import axios from '@/libs/api.request'
import config from '@/config'

const baseCloudUrl = config.basePrivateCloudUrl
const privateCloudBaseUrl = baseCloudUrl + '/cloud/api/v1/'
export const privateCloudUploadImageUrl = privateCloudBaseUrl + 'upload_image_file/'

export const getPrivateCloudImage = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'image/',
    params: params,
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const getPrivateCloudAllImage = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_image_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudImage = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'image/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudImage = (data, id) => {
  let url = privateCloudBaseUrl + 'image/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    needPrivateCloudProjectHeader: true,
    method: method
  })
}

export const deletePrivateCloudImage = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'image/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}

export const deletePrivateCloudImageFile = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'image_file/' + id + '/',
    method: 'delete'
  })
}
